import { SessionType } from '@core/types';
import { Claim } from '@core/interfaces/claim';

export function userIsAuthenticated(session: SessionType): session is Claim[] {
  return session !== null;
}
